import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import moment from 'moment';
import { getSalesVisitRank } from 'src/services/SalesPerformance/SalesPerformance';
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react';
import Typography from 'src/views/theme/typography/Typography';
import { useNavigate } from 'react-router-dom';

function SalesPerformance() {
  const navigate = useNavigate();

  const [salesList, setSalesList] = useState([]);
  const [renderCounter, setRenderCounter] = useState(0);
  const [loading, setLoading] = useState(true);

  async function fetchVisitRank(month, year) {
    const response = await getSalesVisitRank(month, year);

    setSalesList(response.data);
    setLoading(false);
  }

  useEffect(() => {
    if (renderCounter === 0) {
      fetchVisitRank(
        Moment(new Date()).format('MM'),
        Moment(new Date()).format('YYYY')
      );
      // fetchVisitRank("12", "2022")
    }

    setRenderCounter(renderCounter + 1);
  }, [loading]);

  return (
    <>
      <CCard>
        <CCardBody>
          {!loading &&
            salesList &&
            salesList.map((item, i) => {
              return (
                <CRow style={{ marginBottom: '2vh' }}>
                  <CCol xs="6" style={{ textAlign: 'left' }}>
                    <p className="fs-4">{item.name}</p>
                  </CCol>
                  <CCol xs="6" style={{ textAlign: 'left' }}>
                    <CButton
                      style={{ backgroundColor: '#4E5B97', border: 'none' }}
                      onClick={() => {
                        navigate(`/sales-performance-details`, {
                          state: {
                            salesID: item.id,
                            salesName: item.name,
                            salesEmail: item.email,
                            salesPhone: item.phone
                          }
                        });
                      }}
                    >
                      Detail
                    </CButton>
                  </CCol>
                </CRow>
              );
            })}
        </CCardBody>
      </CCard>
    </>
  );
}

export default SalesPerformance;
